import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoading) return;
        if (isAuthenticated) {
            navigate('/home', { replace: true });
            return;
        }
        loginWithRedirect({ appState: { returnTo: '/home' } });
    }, [isAuthenticated, isLoading, loginWithRedirect, navigate]);

    return (
        <div className='d-flex justify-content-center aligns-Items-center h-100vh'>
            <Spinner accessibilityLabel="Spinner example" size="large" />
        </div>
    );
};

export default Login;
